import { useMutation } from '@tanstack/react-query';

import { updatePurchaseSortMode } from '@widgets/EstimateInformation/api/updatePurchaseSortMode';

export const useUpdatePurchaseSortMode = () =>
    useMutation({
        mutationKey: ['updatePurchaseSortMode'],
        mutationFn: updatePurchaseSortMode,
    });
